import { PluginRegistration } from '@/infra/plugin-registry';
import { CommitmentRejectSection } from './components/CommitmentRejectSection';

// Commitments plugin (web) — chores side of the lifedb "Commitments → TODO"
// feature. lifedb auto-creates these todos; chores renders them with distinct
// per-type list glyphs and a "wrongly created" button in the detail modal.
//
// No web routes / reducer / saga: the plugin only contributes a detail-slot
// renderer and the two type_tags' list icons (surfaced via the registry's
// getIconForTypeTag → TodoItem leading region).
export const commitmentsManifest: PluginRegistration = {
  id: 'commitments',
  display_name: 'Commitments',
  description:
    'Follow-up TODOs auto-created by lifedb when it detects a commitment in your messages or email',
  icon: '🤝',
  version: '1.0.0',
  enabled_by_default: true,
  todo_types: [
    {
      // The user committed to do something ("I'll send the report Friday").
      type_tag: 'commitments.mine',
      label: 'My commitment',
      icon: '🤝',
    },
    {
      // Someone committed something to the user → a follow-up reminder.
      type_tag: 'commitments.followup',
      label: 'Follow-up',
      icon: '⏰',
    },
  ],
  web_routes: [],
  detailSlots: {
    'below-actions': CommitmentRejectSection,
  },
};
